import { AxiosResponse } from 'axios';
import api from '~/services/api';
import { getListProps } from './product-list-interface';

class ProductListService {
  getListProducts(
    { queryString, skip = 0, limit = 100, ...filters }: getListProps,
    opts: any
  ): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/products-default-price', {
      params: {
        queryString,
        skip,
        limit,
        ...filters
      },
      ...opts
    });
  }

  getListProductsCount({ queryString, ...filters }: getListProps, opts: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/product/products-default-price?isCount=true', {
      params: {
        queryString,
        ...filters
      },
      ...opts
    });
  }
}

export default new ProductListService();
